import { Store } from '../../store/store';
import { StoreNode } from '../../store';
import { action, makeObservable, observable } from 'mobx';
import { Maybe, Nullable } from '../../core';
import last from 'lodash/last';

export class OverlayService
  extends StoreNode {

  readonly anchors = observable.map<string, HTMLElement>();

  readonly activeWindows = observable.array<string>();
  get visibleWindow(): Nullable<String> {
    return last(this.activeWindows) || null;
  }

  constructor(store: Store) {
    super(store);
    makeObservable(this);
  }

  @action
  invoke(type: string, payload?: unknown) {

    switch (type) {
      case 'chunkMounted':
        break;

      case 'chunkUnmounted':
        break;

      case 'anchorMounted': {
        const { id, node } = payload as { id: string; node: HTMLElement };
        this.anchors.set(id, node);
        break;
      }

      case 'anchorUnmounted': {
        const { id } = payload as { id: string };
        this.anchors.delete(id);
        break;
      }

      case 'openWindow': {
        const { name } = payload as { name: string };
        this.openWindow(name);
        break;
      }

      case 'closeWindow':
        this.closeWindow();
        break;
      default: break;
    }
  }

  @action
  openWindow(name: string) {
    this.activeWindows.push(name);
  }

  @action
  closeWindow() {
    this.activeWindows.pop();
  }

  getAnchor(id: Maybe<string>): Nullable<HTMLElement> {
    if (!id)
      return null;

    return (
      this.anchors.get(id) ||
      document.getElementById(id) ||
      null);
  }
}